const baseStyle = {
  borderRadius: 0,
}

const defaultProps = {
  variant: 'elevated',
}

const sizes = {}

const variants = {
  elevated: {
    boxShadow: 'sm',
  },
  outlined: {
    border: 1,
    borderColor: 'sandstone.main',
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
